import { useQuery } from "@tanstack/react-query";

import { bannersQueryOptions } from "../../../../lib/queries.js";
import { useShopper } from "../../../../lib/shopper.js";
import { useTerminology } from "../../../../lib/terminology.js";
import type { TemplateAction } from "../../shared/links.js";

/** One slide's art: the wide image from `md` up, the phone image below it. */
export interface HeroArt {
  desktopUrl: string;
  mobileUrl: string;
  alt: string;
}

export interface HeroContent {
  headline: string;
  body: string;
  actions: TemplateAction[];
  /**
   * The first slide of the first banner live for this shopper (Storefront → Banners), until the
   * carousel shows every slide; null when none is live.
   */
  art: HeroArt | null;
}

/** The hero: sign up or log in while signed out, browse the boxes once signed in. */
export function useHeroContent(): HeroContent {
  const { user } = useShopper();
  const { box, item } = useTerminology();
  const banners = useQuery(bannersQueryOptions(user?.id ?? "anon"));
  const slide = banners.data?.[0]?.slides[0];
  return {
    headline: "Rip. Collect. Hold.",
    body: `Open digital ${box.plural}, discover rare ${item.plural}, and build your collection. Love what you opened? Get the real thing delivered straight to your door.`,
    actions: user
      ? [{ label: `Browse ${box.plural}`, emphasis: "primary", to: "/boxes" }]
      : [
          { label: "Sign up", emphasis: "primary", to: "/login" },
          { label: "Log in", emphasis: "secondary", to: "/login" },
        ],
    art: slide
      ? { desktopUrl: slide.desktopImageUrl, mobileUrl: slide.mobileImageUrl, alt: slide.altText }
      : null,
  };
}
